import { useState } from "react";
import { getCodeFromUrl } from "@/modules/gateway/features/open-external-sign/utils/get-code-from-url";

export function useCode() {
  const [code, _] = useState(() => getCodeFromUrl() ?? undefined);

  return {
    code,
  };
}
